import Producers from "./producers";
import QueryProducers from "./query_producers";

export default [...Producers, ...QueryProducers];
